const Logo = ({ height }) => {

  return (
    <img src="/assets/brand/beyhan.png" height={height} alt="" />
  );
};

export default Logo;
